import React, { memo, useMemo } from 'react';
import {
  useIsSearchFiltering,
  useSearchNeedle,
} from '@components/MainStage/listSearch.store';
import { LayerTypes, Modes } from '@constants/canvas/layers';
import { useMenuNodes } from '@context/MenuNodesProvider';
import { useProject } from '@context/Project/ProjectProvider';
import { Box, Typography } from '@mui/material';
import { matchesSearch } from '@utils/searchHighlight';
import LayerMenu from '@views/Project/components/ListMenu/components/LayerMenu';

export const LayerModeMenus = memo(() => {
  const {
    toolbox: { mode },
  } = useProject();

  const isFiltering = useIsSearchFiltering();
  const needle = useSearchNeedle();
  const { nodes } = useMenuNodes();

  const hasMatches = useMemo(
    () => nodes.some((node) => matchesSearch(node.data.dto.label, needle)),
    [nodes, needle],
  );

  if (isFiltering && !hasMatches) {
    return (
      <Box px={3} py={4}>
        <Typography variant="body1" color="grey.800">
          No result
        </Typography>
      </Box>
    );
  }

  if (mode === Modes.BusinessAlignment) {
    return (
      <>
        <LayerMenu layerId={LayerTypes.Contextual} />
        <LayerMenu layerId={LayerTypes.Conceptual} />
        <LayerMenu layerId={LayerTypes.Logical} />
      </>
    );
  }

  if (mode === Modes.Controls) {
    return (
      <>
        <LayerMenu layerId={LayerTypes.Conceptual} />
        <LayerMenu layerId={LayerTypes.Logical} />
        <LayerMenu layerId={LayerTypes.Physical} />
        <LayerMenu layerId={LayerTypes.Component} />
        <LayerMenu layerId={LayerTypes.Initiatives} />
      </>
    );
  }

  return (
    <>
      <LayerMenu layerId={LayerTypes.SensitiveElements} />
      <LayerMenu layerId={LayerTypes.AssociatedRisks} />
      <LayerMenu layerId={LayerTypes.Physical} />
      <LayerMenu layerId={LayerTypes.Initiatives} />
    </>
  );
});
